<template>
  <div>


<!--    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>-->
    <!--    <a class="btn btn-primary" @click="DataItem_AddLast"><i class="fas fa-plus-circle"></i></a>-->
    <a role="button" class="btn btn-primary" @click="NewProduct()">新增</a>
    <a role="button" class="btn btn-primary" @click="SaveOrder()">儲存排序</a>

<!--    查詢訂單-->
<!--    <a role="button" class="btn btn-primary" @click="QueryStatus('payed')">已付款</a>-->
<!--    <a role="button" class="btn btn-primary" @click="QueryStatus('finish')">已完成</a>-->
<!--    <a role="button" class="btn btn-primary" @click="QueryStatus('cancel')">已取消</a>-->

<!--    匯出-->
<!--    <a role="button" class="btn btn-info" onclick="ExportToExcel()">匯出Excel</a>-->

    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th>功能</th>
        <th>名稱</th>
        <th>分類</th>
        <th>價格</th>
        <th>排序</th>
        <th>是否啟用</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item,index) in this.datas" :key="index">
        <td width="300px">
          <a role="button" class="btn btn-primary" href="#" @click="gotoDetail(item.id)">編輯</a>
          <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>
<!--          <span v-if="item.status==='expired'">-->
<!--            <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>-->
<!--          </span>-->

          <a class="btn btn-primary" @click="DataItem_MoveUp(item)"><i class="fa fa-angle-up"></i>  </a>
          <a class="btn btn-primary" @click="DataItem_MoveDown(item)"><i class="fa fa-angle-down"></i>  </a>

        </td>
        <td width="200px">
          {{item.name}}
        </td>
        <td width="200px">
          {{item.categoryId}}
        </td>
        <td width="220px">
          {{item.price}}
        </td>
        <td width="120px">
          {{item.sortOrder}}
        </td>
        <td width="100px">
          <div v-if="item.isActive">
            <a role="button" class="btn btn-primary" href="#" @click="changeIsActive(item.id,0)">啟用</a>
          </div>
          <div v-else>
            <a role="button" class="btn btn-danger" href="#" @click="changeIsActive(item.id,1)">停用</a>
          </div>

        </td>
      </tr>

      </tbody>
    </table>

  </div>
</template>

<script>
/**

 **/


import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";
import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";

export default {
  components: {},
  //name: "setting",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
      datas:{

      },
      queryStatus:"payed",
    };
  },
  methods: {
    NewProduct(){
      this.$router.push({ name: 'ECProductDetail', query: { id: '' }})
    },
    Export(){

    },
    QueryStatus(status){
      this.queryStatus=status;
      this.loadData();
    },
    SaveOrder(){
      // let that=this;

      apiFireGodsec.api_Admin_ECProduct_SaveOrder(this.datas).then((data)=>{
        alert('儲存成功');
      })
    },
    loadData() {
      // let data=apiAdmin.api_getContent(this.queryType);
      // debugger // eslint-disable-line
      // console.log(data);
      let that=this;

      apiFireGodsec.api_Admin_ECProduct_Query().then((data)=>{
        let dataApi=data.data.data;
        // let dataApi=apiAdmin.init(data.data.data);
        that.datas=dataApi;
      })
    },
    // submit(){
    //   debugger // eslint-disable-line
    //   apiFireGodsec.api_Admin_EventDefine_Save(this.datas).then((data)=>{
    //     console.log(data);
    //     alert('儲存成功')
    //   })
    // },
    convertToRealUrl(url){
      return Vue.prototype.$apiAdress.replace(/\/$/, "") +url;
    },
    gotoDetail(id){
      this.$router.push({ name: 'ECProductDetail', query: { id: id }})
    },
    deleteDetail(id){
      //confirm delete
      if(confirm('確定要刪除嗎?')){
        apiFireGodsec.api_Admin_ECProduct_Del(id).then(()=>{
          alert('刪除成功')
          this.loadData();
        })
      }

    },
    changeIsActive(id,isActive){
      apiFireGodsec.api_Admin_ECProduct_ChangeIsActive(id,isActive).then((data)=>{
        console.log(data);
        alert('儲存成功')
        this.loadData();
      })
    },
    DataItem_MoveUp(item){
      arrayUtil.orderMove(false,item.id,this.datas,"id","sortOrder")
    },
    DataItem_MoveDown(item){
      arrayUtil.orderMove(true,item.id,this.datas,"id","sortOrder")
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>

<style scoped>
#tblMain{
  width: 1200px;
}
.btn{
  color: white !important;
  margin: 5px;
  /*width: 40px;*/
}
</style>
